export function Eyebrow({ children, tone = "brass", className = "" }) {
  const colors = {
    brass: "text-brass",
    bone: "text-bone-dim",
    stone: "text-stone",
  };
  return (
    <div
      className={`text-[11px] uppercase tracking-[0.22em] font-medium ${colors[tone] || colors.brass} ${className}`}
    >
      {children}
    </div>
  );
}

export function SectionLabel({ index, label, tone = "brass" }) {
  const color = tone === "bone" ? "text-bone-dim" : "text-brass";
  return (
    <div className={`flex items-center gap-3 text-[11px] uppercase tracking-[0.24em] font-medium ${color}`}>
      <span className="font-semibold">{index}</span>
      <span className="opacity-40">—</span>
      <span>{label}</span>
    </div>
  );
}

export function Ornament({ tone = "brass" }) {
  const c = tone === "bone" ? "border-bone-dim/40" : "border-brass/50";
  return (
    <div className="flex items-center justify-center gap-3 my-6">
      <span className={`block h-px w-10 border-t ${c}`} />
      <span className={`text-xs ${tone === "bone" ? "text-bone-dim" : "text-brass"}`}>✦</span>
      <span className={`block h-px w-10 border-t ${c}`} />
    </div>
  );
}
